import { render, staticRenderFns } from "./Training-wx.vue?vue&type=template&id=6a29c794&scoped=true&"
import script from "./Training-wx.vue?vue&type=script&lang=js&"
export * from "./Training-wx.vue?vue&type=script&lang=js&"
import style0 from "./Training-wx.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Training-wx.vue?vue&type=style&index=1&id=6a29c794&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a29c794",
  null
  
)

export default component.exports